"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
function QueueSearchInput(_a) {
    var value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder;
    var _b = __read(react_1.default.useState(false), 2), searchFocused = _b[0], setSearchFocused = _b[1];
    return (react_1.default.createElement("div", { className: "search-with-icon" },
        react_1.default.createElement("i", { className: (0, clsx_1.default)('eva-search-icon implioicons-search', { focused: searchFocused === true }) }),
        react_1.default.createElement("input", { type: "text", className: "form-control no-border", id: "search-input", placeholder: placeholder, value: value, onChange: onChange, onFocus: function () {
                setSearchFocused(true);
            }, onBlur: function () { return setSearchFocused(false); } })));
}
exports.default = QueueSearchInput;
